import {
  ComponentOverridesLanguageList,
  ComponentOverridesLanguageListAdapter,
  ComponentOverridesLanguageSettings,
  ComponentOverridesLanguageSettingsAdapter,
  ComponentOverridesSettings,
  ComponentOverridesSettingsAdapter
} from "@admin/application-settings/component-overrides/component-overrides.model";
import { inject, Injectable } from "@angular/core";
import { HttpService } from "@app/core/services/http/http.service";
import { IPLUS_URL } from "@app/shared/constants/url.constants";
import { map } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class ComponentOverridesService {
  private http = inject(HttpService);

  fetchComponentSettingsById(data: ComponentOverridesSettings) {
    const respAdapter = new ComponentOverridesSettingsAdapter();
    return this.http
      .addDataParams(data)
      .get<ComponentOverridesSettings>(IPLUS_URL.COMPONENT_OVERRIDES_MAINTENANCE)
      .pipe(map((response: any) => respAdapter.adapt(response)));
  }

  updateComponentSettings(data: ComponentOverridesSettings) {
    const respAdapter = new ComponentOverridesSettingsAdapter();
    return this.http
      .addDataParams(data)
      .put<ComponentOverridesSettings>(IPLUS_URL.COMPONENT_OVERRIDES_MAINTENANCE, "")
      .pipe(map((response: any) => respAdapter.adapt(response)));
  }

  fetchComponentLanguageList(componentId: string) {
    const respAdapter = new ComponentOverridesLanguageListAdapter();
    return this.http
      .addDataParams({ componentId: componentId })
      .get<ComponentOverridesLanguageList>(IPLUS_URL.COMPONENTS_LANGUAGE_LIST)
      .pipe(map((response: any) => respAdapter.adapt(response)));
  }

  fetchComponentLanguageById(data: ComponentOverridesLanguageSettings) {
    const respAdapter = new ComponentOverridesLanguageSettingsAdapter();
    return this.http
      .addDataParams(data)
      .get<ComponentOverridesLanguageSettings>(IPLUS_URL.COMPONENTS_LANGUAGE_MAINTENANCE)
      .pipe(map((response: any) => respAdapter.adapt(response)));
  }

  addComponentLanguageById(data: ComponentOverridesLanguageSettings) {
    const respAdapter = new ComponentOverridesLanguageSettingsAdapter();
    return this.http
      .addDataParams(data)
      .post<ComponentOverridesLanguageSettings>(IPLUS_URL.COMPONENTS_LANGUAGE_MAINTENANCE, "")
      .pipe(map((response: any) => respAdapter.adapt(response)));
  }

  updateComponentLangaugeSettings(data: ComponentOverridesLanguageSettings) {
    const respAdapter = new ComponentOverridesLanguageSettingsAdapter();
    return this.http
      .addDataParams(data)
      .put<ComponentOverridesLanguageSettings>(IPLUS_URL.COMPONENTS_LANGUAGE_MAINTENANCE, "")
      .pipe(map((response: any) => respAdapter.adapt(response)));
  }

  deleteComponentLanguage(componentId: string, language: string) {
    const respAdapter = new ComponentOverridesLanguageListAdapter();
    return this.http
      .addDataParams({ componentId, language })
      .delete<ComponentOverridesLanguageList>(IPLUS_URL.COMPONENTS_LANGUAGE_DELETE)
      .pipe(map((response: any) => respAdapter.adapt(response)));
  }
}
